export default Object.freeze({
  ADULT: 'A',
  CONTRIBUTOR: 'C',
  DEPENDANT: 'D', // Insured Child Dependant
  STUDENT: 'S', // Insured Student Dependant
  NON_STUDENT: 'N', // Insured Non Student Dependant
  YASP: 'Y', // Insured Young Adult
  RESPONSIBLE: 'R',
});
